const TOPICS = [
  { label: '明星恋情曝光', heat: '987万', trend: 'up', icon: 'ri-heart-pulse-line' },
  { label: '综艺剪辑争议', heat: '756万', trend: 'up', icon: 'ri-tv-line' },
  { label: '网红直播翻车', heat: '654万', trend: 'hot', icon: 'ri-live-line' },
  { label: '影视剧透爆料', heat: '543万', trend: 'up', icon: 'ri-clapperboard-line' },
  { label: '音乐抄袭风波', heat: '432万', trend: 'stable', icon: 'ri-music-2-line' },
  { label: '体育圈内幕', heat: '389万', trend: 'up', icon: 'ri-medal-line' },
  { label: '时尚圈撕逼', heat: '321万', trend: 'down', icon: 'ri-shirt-line' },
  { label: '配音圈黑幕', heat: '287万', trend: 'hot', icon: 'ri-mic-line' },
  { label: '选秀节目内定', heat: '256万', trend: 'up', icon: 'ri-trophy-line' },
  { label: '编剧圈纠纷', heat: '198万', trend: 'stable', icon: 'ri-quill-pen-line' },
  { label: '导演圈潜规则', heat: '165万', trend: 'down', icon: 'ri-camera-line' },
];

export default function TopicsSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-accent-500';
    if (trend === 'hot') return 'ri-fire-line text-accent-500';
    if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">全网热议的黑料视频话题实时追踪，热度数据每小时更新</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {TOPICS.map((topic, idx) => (
            <a
              key={idx}
              href="#"
              className="flex items-center gap-3 p-3 md:p-4 bg-background-100 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                <i className={`${topic.icon} text-foreground-700 group-hover:text-primary-600 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate">{topic.label}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{topic.heat} 热度</span>
                  <i className={getTrendIcon(topic.trend)}></i>
                </div>
              </div>
              {idx < 3 && (
                <span className={`px-2 py-0.5 rounded-full text-xs font-semibold flex-shrink-0 ${
                  idx === 0 ? 'bg-accent-500 text-background-50' :
                  idx === 1 ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-900'
                }`}>
                  TOP{idx + 1}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}